module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "checkout-review"
  }, [_c('h4', [_vm._v("Review Order")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "warning",
      "value": true
    }
  }, [_vm._v("\n    Please review your order carefully. ORDERS CANNOT BE CHANGED OR CANCELED after they are submitted to our fully-automated production process.\n  ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("\n        Shipping Information\n        "), _c('v-tooltip', {
    staticClass: "btn-group",
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('update-step', 1)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Shipping Info")])], 1)], 1), _vm._v(" "), (_vm.cart) ? _c('display-address', {
    attrs: {
      "data": _vm.cart.shipping_address
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("\n        Billing Information\n        "), _c('v-tooltip', {
    staticClass: "btn-group",
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('update-step', 1)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Billing Info")])], 1)], 1), _vm._v(" "), (_vm.cart) ? _c('display-address', {
    attrs: {
      "data": _vm.cart.billing_address
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "fancy"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "left-side"
  }), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Item Description")]), _vm._v(" "), _c('th', {
    staticClass: "right-align"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "right-align"
  }, [_vm._v("Unit Price")]), _vm._v(" "), _c('th', {
    staticClass: "right-align"
  }, [_vm._v("Extended price")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cart.cart_items), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "left-side"
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "left mr-3"
    }, [(item.file) ? _c('img', {
      attrs: {
        "src": item.file.thumbs.small,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('item-description', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "right-align"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "right-align"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.unitPrice(item.quantity, item.unit_prices))))]), _vm._v(" "), _c('td', {
      staticClass: "right-align"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.unitPrice(item.quantity, item.unit_prices) * item.quantity)))])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "plain",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Shipping Method:")]), _vm._v("\n            " + _vm._s(_vm.cart.shipping_method_title) + "\n            "), _c('v-tooltip', {
    staticClass: "btn-group",
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('update-step', 2)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Shipping Method")])], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "right-align semibold"
  }, [_vm._v("\n            Order Total"), _c('br'), _vm._v("\n            Shipping & Processing"), _c('br'), _vm._v("\n            Sales Tax"), _c('br'), _vm._v("\n            Order Total\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "right-align"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.cart.subtotal_price))), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("doubleDashForZero")(_vm._f("currency")(_vm.totalShipping)))), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("doubleDashForZero")(_vm._f("currency")(_vm.cart.total_tax)))), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.cart.total_price)) + "\n          ")])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "my-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      The Order Total of "), _c('b', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.cart.total_price)))]), _vm._v(" USD will be charged to your Credit Card with Gung-Ho Company as the Merchant.\n    ")])], 1), _vm._v(" "), _c('v-checkbox', {
    staticClass: "gh-input",
    attrs: {
      "label": "I have reviewed my order, read and agree to the Terms and Conditions, and understand my order cannot be changed or canceled after it is submitted."
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8650b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/review-order.vue
// module id = 760
// module chunks = 1